// extracted by mini-css-extract-plugin
module.exports = {"container":"_23neN","content":"nh-UN","section":"_351GC","sectionTitle":"_168El","sectionDescription":"WTKAn","separator":"_2Dl4o"};